
import { privateAxios } from "../../../config/apiConfig";
import { GET_PAYMENTS_FAILURE, GET_PAYMENTS_REQUEST, GET_PAYMENTS_SUCCESS } from "./ActionType";


export const getPayments = () => async (dispatch) => {
    dispatch({ type: GET_PAYMENTS_REQUEST })
    try {
        const { data } = await privateAxios.get(`vendor/payments`);
        dispatch({ type: GET_PAYMENTS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_PAYMENTS_FAILURE, payload: error.message })
    }
}
